import { CodeVerificationWidget } from "../../widgets/code-verification/CodeVerification";
import { FC } from "react";

interface Props {
  onSignUp: () => void;
}

export const EmailVerificationPage: FC<Props> = ({ onSignUp }) => {
  return (
    <>
      <CodeVerificationWidget onContinue={onSignUp} />
    </>
  );
};
